import { AccessToken } from '@okta/okta-auth-js';
import { useOktaAuth } from '@okta/okta-react';
import get from 'lodash/get';
import getEmptyForNull from '../utils/utils';
import { UserDetailsResponse } from '../adapters/types';
import useUserDetails from './useClientDataServices';

type UseUserInfoReturn = {
  userInfo?: UserDetailsResponse;
  accessToken: AccessToken;
  isFetching: boolean;
  isError: boolean;
  isApprover: boolean;
};

const useUserInfo = (): UseUserInfoReturn => {
  const { authState } = useOktaAuth();
  const { data, isFetching, isError } = useUserDetails(
    getEmptyForNull(authState?.accessToken?.accessToken),
    getEmptyForNull(authState?.accessToken?.claims?.cdksid.toString()),
  );

  return {
    userInfo: data ?? ({} as UserDetailsResponse),
    accessToken: get(authState, 'accessToken', {}) as unknown as AccessToken,
    isFetching,
    isError,
    isApprover: false,
  };
};

export default useUserInfo;
